"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The postnl module provides the means to retrieve and set a PostNL pickup location
 * @preferred
 */
var service_1 = require("../service");
var PostNL = /** @class */ (function () {
    /**
     * [constructor description]
     * @param  {Order}  order The order to perform the payments for
     * @return {void}         This method doesn't return anything
     */
    function PostNL(order) {
        this.order = order;
    }
    PostNL.prototype.PostNLGetAvailablePickUpLocationsForArea = function (orderId, nw, se) {
        // Create our service instance
        //
        var service = new service_1.EVAService("PostNLGetAvailablePickUpLocationsForArea");
        // Build the request data
        // The base class will add things like SessionID so to keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            OrderID: orderId,
            NorthWest: nw,
            SouthEast: se
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData);
    };
    PostNL.prototype.PostNLGetAvailablePickUpLocationsForOrder = function (orderId) {
        // Create our service instance
        //
        var service = new service_1.EVAService("PostNLGetAvailablePickUpLocationsForOrder");
        // Build the request data
        // The base class will add things like SessionID so to keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            OrderID: orderId
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData);
    };
    PostNL.prototype.PostNLGetAvailableTimeframesForOrder = function (orderId, startDate, endDate) {
        // Create our service instance
        //
        var service = new service_1.EVAService("PostNLGetAvailableTimeframesForOrder");
        // Build the request data
        // The base class will add things like SessionID so to keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            OrderID: orderId,
            StartDate: startDate,
            EndDate: endDate
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData);
    };
    PostNL.prototype.PostNLGetShippingOptionsForOrder = function (orderId) {
        // Create our service instance
        //
        var service = new service_1.EVAService("PostNLGetShippingOptionsForOrder");
        // Build the request data
        // The base class will add things like SessionID so to keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            OrderID: orderId
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData);
    };
    PostNL.prototype.PostNLUpdateShippingOptionsForOrder = function (orderId, pickupLocationId, date, option) {
        // Create our service instance
        //
        var service = new service_1.EVAService("PostNLUpdateShippingOptionsForOrder");
        // Build the request data
        // The base class will add things like SessionID so to keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            OrderID: orderId,
            PickUpLocationID: pickupLocationId,
            Date: date,
            TimeframeOptions: option
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData);
    };
    return PostNL;
}());
exports.PostNL = PostNL;
